/**
 * iOS WebView Controls Boot File
 *
 * Version: 4 - Moved main logic to MainLayout.vue for proper user detection
 *
 * This boot file is now minimal. The actual iOS WebView controls logic
 * has been moved to MainLayout.vue where we have access to userData
 * after the API call completes.
 *
 * See: src/layouts/MainLayout.vue -> initIosWebviewControls()
 */

import { boot } from "quasar/wrappers";

export default boot(() => {
    console.log('[iOS WebView Controls v4] Boot file loaded - main logic now in MainLayout.vue');
});

// Export empty functions for backwards compatibility
export const getWebkitHandler = () => null;
export const isIosWebView = () => false;
export const isAndroidWebView = () => false;
export const getPlatform = () => 'web';
export const callIosBridge = () => false;
export const callAndroidBridge = () => false;
export const applyControlForRoute = () => {};
export const fetchAllControls = async () => [];
